export const sizes = {
    appBarHeight: "56px",
    navbarWidth: "56px",
};
